export const MEAL_IMAGE_ASPECT_RATIO = 16 / 9;
